import React from "react";

const URL_REGEX = /(https?:\/\/[^\s]+)/g;
const BOLD_REGEX = /\*\*(.+?)\*\*/g;

function renderBoldSegments(text, keyPrefix) {
  const segments = [];
  let lastIndex = 0;
  let match;

  BOLD_REGEX.lastIndex = 0;

  while ((match = BOLD_REGEX.exec(text)) !== null) {
    const [fullMatch, boldText] = match;
    const matchIndex = match.index;

    if (matchIndex > lastIndex) {
      segments.push(text.slice(lastIndex, matchIndex));
    }

    segments.push(
      <strong key={`${keyPrefix}-bold-${matchIndex}`}>{boldText}</strong>,
    );

    lastIndex = matchIndex + fullMatch.length;
  }

  if (lastIndex < text.length) {
    segments.push(text.slice(lastIndex));
  }

  return segments.length > 0 ? segments : [text];
}

function renderInlineMarkdown(text, keyPrefix) {
  const parts = text.split(URL_REGEX);

  return parts.flatMap((part, index) => {
    if (!part) return [];

    if (URL_REGEX.test(part)) {
      URL_REGEX.lastIndex = 0;

      return (
        <a
          key={`${keyPrefix}-link-${index}`}
          href={part}
          target="_blank"
          rel="noreferrer noopener"
        >
          {part}
        </a>
      );
    }

    URL_REGEX.lastIndex = 0;
    return renderBoldSegments(part, `${keyPrefix}-text-${index}`);
  });
}

export default function ChatMessageContent({ content }) {
  if (!content) return null;

  const lines = content.split("\n");

  return (
    <div className="ai-chat_messageContent">
      {lines.map((line, index) => (
        <React.Fragment key={`line-${index}`}>
          {renderInlineMarkdown(line, `line-${index}`)}
          {index < lines.length - 1 ? <br /> : null}
        </React.Fragment>
      ))}
    </div>
  );
}
